/* ==========================================================================
   Best Use Auto Parts - FITMENT OVERRIDES  (safe to edit, NOT obfuscated)
   Loaded before buap-fitment-engine.js. makeCompat: rebadged make groups.
   interchange: platform-sharing siblings carrying the SAME physical part.
   Catalog-derived; runtime still gates every match on exact year + VIN-digit + disp.

   175 groups. FINAL GATE (2026-09-16): every group tested against the
   catalog for car/truck VIN-char collisions; any group where a car and a truck share
   the same displacement + VIN engine-char in the same year was REMOVED (8 groups:
   car 5.7/6.1 HEMI vs Ram, Camry vs Tacoma, F150 vs Monterey, Ranger vs Taurus, M56 vs NV).
   Do NOT re-add a car+truck group without per-year VIN-char proof.
   ========================================================================== */
window.BUAP_FIT_OVERRIDES = {
  makeCompat: [
    ["scion", "toyota"]
  ],
  interchange: [
    /* gm: 2500series, express, express1500, express2500, express3500, series, savana */
    ["chevy|1500","chevy|2500","chevy|2500series","chevy|3500","chevy|express","chevy|express1500","chevy|express2500","chevy|express3500","chevy|series","gmc|1500","gmc|2500","gmc|2500series","gmc|3500","gmc|savana","gmc|savana1500","gmc|savana2500","gmc|savana3500","gmc|series"],
    /* gm: express, express1500, express2500, express3500, 1500series, savana, savana1500 */
    ["chevy|1500","chevy|2500","chevy|3500","chevy|express","chevy|express1500","chevy|express2500","chevy|express3500","gmc|1500","gmc|1500series","gmc|2500","gmc|3500","gmc|savana","gmc|savana1500","gmc|savana2500","gmc|savana3500","gmc|series"],
    /* gm: express, express2500, express3500, silverado, silverado1500, savana, savana2500 */
    ["chevy|1500","chevy|2500","chevy|3500","chevy|express","chevy|express2500","chevy|express3500","chevy|silverado","chevy|silverado1500","gmc|1500","gmc|2500","gmc|3500","gmc|savana","gmc|savana2500","gmc|savana3500","gmc|sierra","gmc|sierra1500"],
    /* gm: 2500series, express, express2500, express3500, series, 3500series, savana */
    ["chevy|2500","chevy|2500series","chevy|3500","chevy|express","chevy|express2500","chevy|express3500","chevy|series","gmc|2500","gmc|2500series","gmc|3500","gmc|3500series","gmc|savana","gmc|savana2500","gmc|savana3500","gmc|series"],
    /* gm: express, express1500, express2500, express3500, savana, savana1500, savana2500 */
    ["chevy|1500","chevy|2500","chevy|3500","chevy|express","chevy|express1500","chevy|express2500","chevy|express3500","gmc|1500","gmc|2500","gmc|3500","gmc|savana","gmc|savana1500","gmc|savana2500","gmc|savana3500"],
    /* stla: 2500series, dakota, durango, series, 1500series, 3500series */
    ["dodge|1500","dodge|2500","dodge|2500series","dodge|3500","dodge|dakota","dodge|durango","dodge|series","ram|1500","ram|1500series","ram|2500","ram|2500series","ram|3500","ram|3500series","ram|series"],
    /* gm: 2500series, express, express3500, series, savana, savana3500 */
    ["chevy|2500","chevy|2500series","chevy|3500","chevy|express","chevy|express3500","chevy|series","gmc|2500","gmc|2500series","gmc|3500","gmc|savana","gmc|savana3500","gmc|series"],
    /* gm: 2500series, express, express2500, express3500, series, savana, savana2500 */
    ["chevy|2500","chevy|2500series","chevy|3500","chevy|express","chevy|express2500","chevy|express3500","chevy|series","gmc|2500","gmc|3500","gmc|savana","gmc|savana2500","gmc|savana3500"],
    /* stla: 2500series, dakota, durango, series, 3500series */
    ["dodge|1500","dodge|2500","dodge|2500series","dodge|3500","dodge|dakota","dodge|durango","dodge|series","ram|2500","ram|2500series","ram|3500","ram|3500series","ram|series"],
    /* stla: 2500series, series, 1500series, 3500series */
    ["dodge|1500","dodge|2500","dodge|2500series","dodge|3500","dodge|series","ram|1500","ram|1500series","ram|2500","ram|2500series","ram|3500","ram|3500series","ram|series"],
    /* gm: silverado, silverado3500, sierra, sierra2500, sierra3500, sierradenali, sierradenali2500 */
    ["chevy|3500","chevy|silverado","chevy|silverado3500","gmc|2500","gmc|3500","gmc|sierra","gmc|sierra2500","gmc|sierra3500","gmc|sierradenali","gmc|sierradenali2500","gmc|sierradenali3500"],
    /* gm: express, express2500, express3500, savana, savana2500, savana3500 */
    ["chevy|2500","chevy|3500","chevy|express","chevy|express2500","chevy|express3500","gmc|2500","gmc|3500","gmc|savana","gmc|savana2500","gmc|savana3500"],
    /* gm: express, express1500, express2500, savana, savana1500, savana2500 */
    ["chevy|1500","chevy|2500","chevy|express","chevy|express1500","chevy|express2500","gmc|1500","gmc|2500","gmc|savana","gmc|savana1500","gmc|savana2500"],
    /* stla: 2500series, series, viper, 3500series */
    ["dodge|2500","dodge|2500series","dodge|3500","dodge|series","dodge|viper","ram|2500","ram|2500series","ram|3500","ram|3500series","ram|series"],
    /* stla: 2500series, series, 3500series */
    ["dodge|2500","dodge|2500series","dodge|3500","dodge|series","ram|2500","ram|2500series","ram|3500","ram|3500series","ram|series"],
    /* gm: express, express2500, express3500, savana, savana3500 */
    ["chevy|2500","chevy|3500","chevy|express","chevy|express2500","chevy|express3500","gmc|3500","gmc|savana","gmc|savana3500"],
    /* gm: silverado, silverado1500, sierra, sierra1500, sierradenali, sierradenali1500 */
    ["chevy|1500","chevy|silverado","chevy|silverado1500","gmc|1500","gmc|sierra","gmc|sierra1500","gmc|sierradenali","gmc|sierradenali1500"],
    /* toyota: es350, rx350, avalon, camry, highlander, rav4, sienna */
    ["lexus|es350","lexus|rx350","toyota|avalon","toyota|camry","toyota|highlander","toyota|rav4","toyota|sienna","toyota|venza"],
    /* nissan: qx56, armada, nv, nv2500, nv3500, pathfinder */
    ["infiniti|qx56","nissan|2500","nissan|3500","nissan|armada","nissan|nv","nissan|nv2500","nissan|nv3500","nissan|pathfinder"],
    /* ford: e150, e250, e350, excursion, f250superduty, f350superduty, navigator */
    ["ford|e150","ford|e250","ford|e350","ford|excursion","ford|f250superduty","ford|f350superduty","lincoln|navigator"],
    /* toyota: es330, rx330, rx400h, camry, highlander, sienna, solara */
    ["lexus|es330","lexus|rx330","lexus|rx400h","toyota|camry","toyota|highlander","toyota|sienna","toyota|solara"],
    /* toyota: es300, rx300, avalon, camry, highlander, sienna, solara */
    ["lexus|es300","lexus|rx300","toyota|avalon","toyota|camry","toyota|highlander","toyota|sienna","toyota|solara"],
    /* stla: durango, 1500series, series */
    ["dodge|1500","dodge|2500","dodge|3500","dodge|durango","ram|1500","ram|1500series","ram|series"],
    /* stla: dakota, durango, grandcherokee, 1500series, series */
    ["dodge|1500","dodge|dakota","dodge|durango","jeep|grandcherokee","ram|1500","ram|1500series","ram|series"],
    /* nissan: g37, m37, q50, q60, q70, qx70, 370z */
    ["infiniti|g37","infiniti|m37","infiniti|q50","infiniti|q60","infiniti|q70","infiniti|qx70","nissan|370z"],
    /* stla: 2500series, series */
    ["dodge|2500","dodge|2500series","dodge|series","ram|2500","ram|2500series","ram|series"],
    /* gm: silverado, silverado1500, sierra, sierra1500 */
    ["chevy|1500","chevy|silverado","chevy|silverado1500","gmc|1500","gmc|sierra","gmc|sierra1500"],
    /* ford: e150, e250, e350, f250superduty, f350superduty, navigator */
    ["ford|e150","ford|e250","ford|e350","ford|f250superduty","ford|f350superduty","lincoln|navigator"],
    /* gm: express, express3500, savana, savana3500 */
    ["chevy|3500","chevy|express","chevy|express3500","gmc|3500","gmc|savana","gmc|savana3500"],
    /* gm: express, express1500, savana, savana1500 */
    ["chevy|1500","chevy|express","chevy|express1500","gmc|1500","gmc|savana","gmc|savana1500"],
    /* toyota: es300h, camry, highlander, rav4, sienna, venza */
    ["lexus|es300h","toyota|camry","toyota|highlander","toyota|rav4","toyota|sienna","toyota|venza"],
    /* gm: silverado, silverado1500, sierra, sierra2500 */
    ["chevy|1500","chevy|silverado","chevy|silverado1500","gmc|2500","gmc|sierra","gmc|sierra2500"],
    /* gm: parkave, regal, regalsomerset, bonneville, grandprix */
    ["buick|parkave","buick|regal","buick|regalsomerset","pontiac|bonneville","pontiac|grandprix"],
    /* toyota: es300h, nx300h, avalon, camry, rav4 */
    ["lexus|es300h","lexus|nx300h","toyota|avalon","toyota|camry","toyota|rav4"],
    /* stla: dakota, 1500series, series */
    ["dodge|1500","dodge|dakota","ram|1500","ram|1500series","ram|series"],
    /* nissan: qx4, frontier, pathfinder, quest, xterra */
    ["infiniti|qx4","nissan|frontier","nissan|pathfinder","nissan|quest","nissan|xterra"],
    /* nissan: fx, g35, m35, q50, 350z */
    ["infiniti|fx","infiniti|g35","infiniti|m35","infiniti|q50","nissan|350z"],
    /* stla: cirrus, ptcruiser, voyager, caravan, stratus */
    ["chrysler|cirrus","chrysler|ptcruiser","chrysler|voyager","dodge|caravan","dodge|stratus"],
    /* stla: 3500series, series */
    ["dodge|3500","ram|3500","ram|3500series","ram|series"],
    /* stla: 1500series, series */
    ["dodge|1500","ram|1500","ram|1500series","ram|series"],
    /* ford: e150, e250, e350, marklt */
    ["ford|e150","ford|e250","ford|e350","lincoln|marklt"],
    /* ford: edge, explorer, taurus, mkx */
    ["ford|edge","ford|explorer","ford|taurus","lincoln|mkx"],
    /* toyota: gx470, 4runner, sequoia, tundra */
    ["lexus|gx470","toyota|4runner","toyota|sequoia","toyota|tundra"],
    /* ford: fusion, mkz, milan */
    ["ford|fusion","lincoln|mkz","mercury|milan"],
    /* ford: edge, taurus, mkx */
    ["ford|edge","ford|taurus","lincoln|mkx"],
    /* stla: challenger, charger */
    ["chrysler|300","dodge|challenger","dodge|charger"],
    /* toyota: rx450hybrid, rx450hybridl, highlander */
    ["lexus|rx450hybrid","lexus|rx450hybridl","toyota|highlander"],
    /* toyota: gx460, sequoia, tundra */
    ["lexus|gx460","toyota|sequoia","toyota|tundra"],
    /* toyota: ct200h, corolla, prius */
    ["lexus|ct200h","toyota|corolla","toyota|prius"],
    /* nissan: qx60, murano, pathfinder */
    ["infiniti|qx60","nissan|murano","nissan|pathfinder"],
    /* stla: dakota, cherokee, wrangler */
    ["dodge|dakota","jeep|cherokee","jeep|wrangler"],
    /* stla: cirrus, sebring, stratus */
    ["chrysler|cirrus","chrysler|sebring","dodge|stratus"],
    /* nissan: qx50, altima */
    ["infiniti|qx50","nissan|altima"],
    /* jlr: ftype, rangeroversport */
    ["jaguar|ftype","landrover|rangeroversport"],
    /* ford: explorer, mountaineer */
    ["ford|explorer","mercury|mountaineer"],
    /* stla: aspen, durango */
    ["chrysler|aspen","dodge|durango"],
    /* ford: taurus, sable */
    ["ford|taurus","mercury|sable"],
    /* ford: fusion, milan */
    ["ford|fusion","mercury|milan"],
    /* ford: escape, mariner */
    ["ford|escape","mercury|mariner"],
    /* stla: charger */
    ["chrysler|300","dodge|charger"],
    /* bmw: minicoopercountryman, coopercountryman */
    ["bmw|minicoopercountryman","mini|coopercountryman"],
    /* toyota: rx450hybrid, highlander */
    ["lexus|rx450hybrid","toyota|highlander"],
    /* nissan: qx60, pathfinder */
    ["infiniti|qx60","nissan|pathfinder"],
    /* ford: thunderbird, ls */
    ["ford|thunderbird","lincoln|ls"],
    /* stla: townandcountry, caravan */
    ["chrysler|townandcountry","dodge|caravan"],
    /* gm: express, express2500, express3500, silverado, silverado1500, tahoe, savana */
    ["chevy|1500","chevy|2500","chevy|3500","chevy|express","chevy|express2500","chevy|express3500","chevy|silverado","chevy|silverado1500","chevy|tahoe","gmc|1500","gmc|2500","gmc|3500","gmc|savana","gmc|savana2500","gmc|savana3500","gmc|sierra","gmc|sierra1500","gmc|yukon"],
    /* gm: express, express2500, express3500, silverado, silverado2500, silverado3500, savana */
    ["chevy|2500","chevy|3500","chevy|express","chevy|express2500","chevy|express3500","chevy|silverado","chevy|silverado2500","chevy|silverado3500","gmc|2500","gmc|3500","gmc|savana","gmc|savana2500","gmc|savana3500","gmc|sierra","gmc|sierra2500","gmc|sierra3500"],
    /* gm: escalade, esv, camaro, silverado, silverado1500, tahoe, sierra */
    ["cadillac|escalade","cadillac|esv","chevy|1500","chevy|camaro","chevy|silverado","chevy|silverado1500","chevy|tahoe","gmc|1500","gmc|sierra","gmc|sierra1500","gmc|sierradenali","gmc|sierradenali1500","gmc|yukon","gmc|yukonxl1500"],
    /* gm: escalade, avalanche, avalanche1500, express, express1500, silverado, silverado1500 */
    ["cadillac|escalade","chevy|1500","chevy|avalanche","chevy|avalanche1500","chevy|express","chevy|express1500","chevy|silverado","chevy|silverado1500","chevy|tahoe","gmc|1500","gmc|sierra","gmc|sierra1500","gmc|yukon","gmc|yukonxl1500"],
    /* gm: 2500series, 3500series, express, express2500, express3500, series, savana */
    ["chevy|2500","chevy|2500series","chevy|3500","chevy|3500series","chevy|express","chevy|express2500","chevy|express3500","chevy|series","gmc|2500","gmc|3500","gmc|savana","gmc|savana2500","gmc|savana3500"],
    /* gm: silverado, silverado2500, silverado3500, sierra, sierra2500, sierra3500, sierradenali */
    ["chevy|2500","chevy|3500","chevy|silverado","chevy|silverado2500","chevy|silverado3500","gmc|2500","gmc|3500","gmc|sierra","gmc|sierra2500","gmc|sierra3500","gmc|sierradenali","gmc|sierradenali2500","gmc|sierradenali3500"],
    /* vw: a3, a4, a5, a6, allroad, allroada4, q3 */
    ["audi|a3","audi|a4","audi|a5","audi|a6","audi|allroad","audi|allroada4","audi|q3","audi|q5","audi|s3","audi|tt","volkswagen|cabrio","volkswagen|golf"],
    /* gm: 2500series, 3500series, express, express3500, series */
    ["chevy|2500","chevy|2500series","chevy|3500","chevy|3500series","chevy|express","chevy|express3500","chevy|series","gmc|2500","gmc|2500series","gmc|3500","gmc|3500series","gmc|series"],
    /* gm: avalanche, avalanche1500, silverado, silverado1500, tahoe, sierra, sierra1500 */
    ["chevy|1500","chevy|avalanche","chevy|avalanche1500","chevy|silverado","chevy|silverado1500","chevy|tahoe","gmc|1500","gmc|sierra","gmc|sierra1500","gmc|yukon","gmc|yukonxl1500"],
    /* gm: silverado, silverado2500, silverado3500, sierra, sierra2500, sierra3500 */
    ["chevy|2500","chevy|3500","chevy|silverado","chevy|silverado2500","chevy|silverado3500","gmc|2500","gmc|3500","gmc|sierra","gmc|sierra2500","gmc|sierra3500"],
    /* vw: a6, a7, a8, q5, q7, s4, s5 */
    ["audi|a6","audi|a7","audi|a8","audi|q5","audi|q7","audi|s4","audi|s5","audi|sq5","porsche|macan","volkswagen|touareg"],
    /* gm: lesabre, parkave, regal, regalsomerset, camaro, impala, montecarlo */
    ["buick|lesabre","buick|parkave","buick|regal","buick|regalsomerset","chevy|camaro","chevy|impala","chevy|montecarlo","pontiac|bonneville","pontiac|firebird","pontiac|grandprix"],
    /* gm: lacrosse, regal, regalsomerset, ats, ct6, cts, xt5 */
    ["buick|lacrosse","buick|regal","buick|regalsomerset","cadillac|ats","cadillac|ct6","cadillac|cts","cadillac|xt5","chevy|blazer","chevy|camaro","gmc|acadia"],
    /* gm: cavalier, cobalt, elcamino, malibu, g5, grandam, pursuit */
    ["chevy|cavalier","chevy|cobalt","chevy|elcamino","chevy|malibu","pontiac|g5","pontiac|grandam","pontiac|pursuit","pontiac|sunfire","saturn|ion","saturn|lseries"],
    /* nissan: fx, jx35, m35, q50, qx60, 350z, maxima */
    ["infiniti|fx","infiniti|jx35","infiniti|m35","infiniti|q50","infiniti|qx60","nissan|350z","nissan|maxima","nissan|murano","nissan|pathfinder","nissan|quest"],
    /* gm: silverado, silverado1500, sierra, sierra1500, sierradenali, sierradenali1500, yukon */
    ["chevy|1500","chevy|silverado","chevy|silverado1500","gmc|1500","gmc|sierra","gmc|sierra1500","gmc|sierradenali","gmc|sierradenali1500","gmc|yukon","gmc|yukonxl1500"],
    /* vw: a4, allroad, allroada4, q5, beetlebug, cabrio, golf */
    ["audi|a4","audi|allroad","audi|allroada4","audi|q5","volkswagen|beetlebug","volkswagen|cabrio","volkswagen|golf","volkswagen|jetta","volkswagen|tiguan"],
    /* gm: lucerne, terraza, elcamino, impala, malibu, montecarlo, uplander */
    ["buick|lucerne","buick|terraza","chevy|elcamino","chevy|impala","chevy|malibu","chevy|montecarlo","chevy|uplander","pontiac|g6","pontiac|montana"],
    /* gm: avalanche, avalanche1500, silverado, silverado1500, sierra, sierra1500, yukonxl1500 */
    ["chevy|1500","chevy|avalanche","chevy|avalanche1500","chevy|silverado","chevy|silverado1500","gmc|1500","gmc|sierra","gmc|sierra1500","gmc|yukonxl1500"],
    /* gm: escalade, silverado, silverado1500, tahoe, sierra, sierra1500, yukon */
    ["cadillac|escalade","chevy|1500","chevy|silverado","chevy|silverado1500","chevy|tahoe","gmc|1500","gmc|sierra","gmc|sierra1500","gmc|yukon"],
    /* gm: rendezvous, impala, montecarlo, venture, aztek, grandam, montana */
    ["buick|rendezvous","chevy|impala","chevy|montecarlo","chevy|venture","pontiac|aztek","pontiac|grandam","pontiac|montana","pontiac|transsport"],
    /* gm: lucerne, concours, deville, dhs, dts, eldorado, seville */
    ["buick|lucerne","cadillac|concours","cadillac|deville","cadillac|dhs","cadillac|dts","cadillac|eldorado","cadillac|seville","pontiac|bonneville"],
    /* jlr: ftype, vandenplas, xf, xj8, xjr, xjseries, rangerover */
    ["jaguar|ftype","jaguar|vandenplas","jaguar|xf","jaguar|xj8","jaguar|xjr","jaguar|xjseries","landrover|rangerover","landrover|rangeroversport"],
    /* stla: sebring, avenger, challenger, charger, intrepid, journey, magnum */
    ["chrysler|300","chrysler|sebring","dodge|avenger","dodge|challenger","dodge|charger","dodge|intrepid","dodge|journey","dodge|magnum"],
    /* stla: concorde, sebring, avenger, charger, intrepid, magnum, stratus */
    ["chrysler|300","chrysler|concorde","chrysler|sebring","dodge|avenger","dodge|charger","dodge|intrepid","dodge|magnum","dodge|stratus"],
    /* vw: a3, a6, q5, beetlebug, golfgti, jetta, jettagli */
    ["audi|a3","audi|a6","audi|q5","volkswagen|beetlebug","volkswagen|golfgti","volkswagen|jetta","volkswagen|jettagli"],
    /* honda: mdx, rl, rlx, crosstour, odyssey, pilot, ridgeline */
    ["acura|mdx","acura|rl","acura|rlx","honda|crosstour","honda|odyssey","honda|pilot","honda|ridgeline"],
    /* vw: a4, a6, eurovan, golfgti, jetta, jettagli, passat */
    ["audi|a4","audi|a6","volkswagen|eurovan","volkswagen|golfgti","volkswagen|jetta","volkswagen|jettagli","volkswagen|passat"],
    /* gm: enclave, lacrosse, cts, sts, camaro, traverse, acadia */
    ["buick|enclave","buick|lacrosse","cadillac|cts","cadillac|sts","chevy|camaro","chevy|traverse","gmc|acadia"],
    /* gm: century, regal, regalsomerset, elcamino, luminacar, malibu, grandprix */
    ["buick|century","buick|regal","buick|regalsomerset","chevy|elcamino","chevy|luminacar","chevy|malibu","pontiac|grandprix"],
    /* gm: lucerne, concours, deville, dhs, dts, eldorado, seville */
    ["buick|lucerne","cadillac|concours","cadillac|deville","cadillac|dhs","cadillac|dts","cadillac|eldorado","cadillac|seville"],
    /* gm: escalade, esv, ext, tahoe, sierradenali, yukon, yukonxl1500 */
    ["cadillac|escalade","cadillac|esv","cadillac|ext","chevy|tahoe","gmc|sierradenali","gmc|yukon","gmc|yukonxl1500"],
    /* vw: a4, beetlebug, cabrio, golf, jetta, passat */
    ["audi|a4","volkswagen|beetlebug","volkswagen|cabrio","volkswagen|golf","volkswagen|jetta","volkswagen|passat"],
    /* vw: a3, a4, tt, beetlebug, jetta, passat */
    ["audi|a3","audi|a4","audi|tt","volkswagen|beetlebug","volkswagen|jetta","volkswagen|passat"],
    /* honda: rdx, tlx, accord, odyssey, pilot, ridgeline */
    ["acura|rdx","acura|tlx","honda|accord","honda|odyssey","honda|pilot","honda|ridgeline"],
    /* honda: rlx, tlx, accord, crosstour, pilot, ridgeline */
    ["acura|rlx","acura|tlx","honda|accord","honda|crosstour","honda|pilot","honda|ridgeline"],
    /* gm: lacrosse, regal, regalsomerset, elcamino, impala, malibu */
    ["buick|lacrosse","buick|regal","buick|regalsomerset","chevy|elcamino","chevy|impala","chevy|malibu"],
    /* gm: elcamino, impala, malibu, montecarlo, g6, aura */
    ["chevy|elcamino","chevy|impala","chevy|malibu","chevy|montecarlo","pontiac|g6","saturn|aura"],
    /* jlr: vandenplas, xj8, xjr, xjseries, rangerover, rangeroversport */
    ["jaguar|vandenplas","jaguar|xj8","jaguar|xjr","jaguar|xjseries","landrover|rangerover","landrover|rangeroversport"],
    /* jlr: epace, fpace, xe, xf, discoverysport, rangeroverevoque */
    ["jaguar|epace","jaguar|fpace","jaguar|xe","jaguar|xf","landrover|discoverysport","landrover|rangeroverevoque"],
    /* vw: a6, a7, q5, q7, touareg */
    ["audi|a6","audi|a7","audi|q5","audi|q7","volkswagen|touareg"],
    /* vw: q3, q5, cabrio, golf, jetta */
    ["audi|q3","audi|q5","volkswagen|cabrio","volkswagen|golf","volkswagen|jetta"],
    /* gm: allure, lacrosse, cts, sts, camaro */
    ["buick|allure","buick|lacrosse","cadillac|cts","cadillac|sts","chevy|camaro"],
    /* nissan: qx60, altima, murano, pathfinder, sentra */
    ["infiniti|qx60","nissan|altima","nissan|murano","nissan|pathfinder","nissan|sentra"],
    /* nissan: g35, 350z, altima, maxima, quest */
    ["infiniti|g35","nissan|350z","nissan|altima","nissan|maxima","nissan|quest"],
    /* nissan: i35, qx4, qx60, maxima, pathfinder */
    ["infiniti|i35","infiniti|qx4","infiniti|qx60","nissan|maxima","nissan|pathfinder"],
    /* ford: f150, f250superduty, f350superduty, marklt, navigator */
    ["ford|f150","ford|f250superduty","ford|f350superduty","lincoln|marklt","lincoln|navigator"],
    /* hk: accent, kona, venue, forte, rio */
    ["hyundai|accent","hyundai|kona","hyundai|venue","kia|forte","kia|rio"],
    /* hk: elantra, genesis, tiburon, forte, optima */
    ["hyundai|elantra","hyundai|genesis","hyundai|tiburon","kia|forte","kia|optima"],
    /* hk: accent, elantra, ioniq, forte, niro */
    ["hyundai|accent","hyundai|elantra","hyundai|ioniq","kia|forte","kia|niro"],
    /* gm: colorado, canyon, savana, savana2500 */
    ["chevy|colorado","gmc|2500","gmc|canyon","gmc|savana","gmc|savana2500"],
    /* gm: escalade, esv, ext, yukon, yukonxl1500 */
    ["cadillac|escalade","cadillac|esv","cadillac|ext","gmc|yukon","gmc|yukonxl1500"],
    /* stla: sebring, charger, magnum, stratus */
    ["chrysler|300","chrysler|sebring","dodge|charger","dodge|magnum","dodge|stratus"],
    /* gm: lucerne, dts, eldorado, seville */
    ["buick|lucerne","cadillac|dts","cadillac|eldorado","cadillac|seville"],
    /* honda: mdx, rdx, tsx, pilot */
    ["acura|mdx","acura|rdx","acura|tsx","honda|pilot"],
    /* gm: rendezvous, terraza, uplander, montana */
    ["buick|rendezvous","buick|terraza","chevy|uplander","pontiac|montana"],
    /* gm: allure, lacrosse, lucerne, grandprix */
    ["buick|allure","buick|lacrosse","buick|lucerne","pontiac|grandprix"],
    /* gm: encore, cruze, sonic, trax */
    ["buick|encore","chevy|cruze","chevy|sonic","chevy|trax"],
    /* gm: elcamino, malibu, g6, vibe */
    ["chevy|elcamino","chevy|malibu","pontiac|g6","pontiac|vibe"],
    /* gm: camaro, corvette, firebird, gto */
    ["chevy|camaro","chevy|corvette","pontiac|firebird","pontiac|gto"],
    /* gm: cobalt, s10s15sonoma, g5 */
    ["chevy|cobalt","chevy|s10s15sonoma","gmc|s10s15sonoma","pontiac|g5"],
    /* ford: e150, e250, f150, monterey */
    ["ford|e150","ford|e250","ford|f150","mercury|monterey"],
    /* ford: ranger, corsair, mkc, mariner */
    ["ford|ranger","lincoln|corsair","lincoln|mkc","mercury|mariner"],
    /* ford: mustang, continental, other, grandmarquis */
    ["ford|mustang","lincoln|continental","lincoln|other","mercury|grandmarquis"],
    /* hk: santafe, tucson, optima, soul */
    ["hyundai|santafe","hyundai|tucson","kia|optima","kia|soul"],
    /* hk: ioniq, veloster, niro, rio */
    ["hyundai|ioniq","hyundai|veloster","kia|niro","kia|rio"],
    /* gm: cts, srx, equinox, terrain */
    ["cadillac|cts","cadillac|srx","chevy|equinox","gmc|terrain"],
    /* stla: concorde, sebring, avenger, intrepid */
    ["chrysler|concorde","chrysler|sebring","dodge|avenger","dodge|intrepid"],
    /* ford: focus, fusion, mkz */
    ["ford|focus","ford|fusion","lincoln|mkz"],
    /* vw: a3, jetta, jettagli */
    ["audi|a3","volkswagen|jetta","volkswagen|jettagli"],
    /* honda: ilx, tsx, accord */
    ["acura|ilx","acura|tsx","honda|accord"],
    /* honda: tlx, accord, crv */
    ["acura|tlx","honda|accord","honda|crv"],
    /* honda: ilx, civic, fit */
    ["acura|ilx","honda|civic","honda|fit"],
    /* vw: a4, a6, touareg */
    ["audi|a4","audi|a6","volkswagen|touareg"],
    /* gm: terraza, uplander, montana */
    ["buick|terraza","chevy|uplander","pontiac|montana"],
    /* gm: prizm, vibe */
    ["chevy|prizm","geo|prizm","pontiac|vibe"],
    /* nissan: qx50, altima, sentra */
    ["infiniti|qx50","nissan|altima","nissan|sentra"],
    /* hk: sonata, sorento, spectra */
    ["hyundai|sonata","kia|sorento","kia|spectra"],
    /* hk: entourage, k900, sedona */
    ["hyundai|entourage","kia|k900","kia|sedona"],
    /* hk: elantra, veloster, rio */
    ["hyundai|elantra","hyundai|veloster","kia|rio"],
    /* hk: g80, genesis, palisade */
    ["genesis|g80","hyundai|genesis","hyundai|palisade"],
    /* gm: colorado, canyon, h3 */
    ["chevy|colorado","gmc|canyon","hummer|h3"],
    /* stla: sebring, intrepid, stratus */
    ["chrysler|sebring","dodge|intrepid","dodge|stratus"],
    /* stla: pacifica, townandcountry, caravan */
    ["chrysler|pacifica","chrysler|townandcountry","dodge|caravan"],
    /* stla: sebring, avenger, stratus */
    ["chrysler|sebring","dodge|avenger","dodge|stratus"],
    /* gm: cts, vue */
    ["cadillac|cts","saturn|vue"],
    /* honda: tlx, accord */
    ["acura|tlx","honda|accord"],
    /* honda: integra, civic */
    ["acura|integra","honda|civic"],
    /* gm: lucerne, dts */
    ["buick|lucerne","cadillac|dts"],
    /* gm: lucerne, impala */
    ["buick|lucerne","chevy|impala"],
    /* gm: encore, cruze */
    ["buick|encore","chevy|cruze"],
    /* gm: enclave, traverse */
    ["buick|enclave","chevy|traverse"],
    /* vw: macan, touareg */
    ["porsche|macan","volkswagen|touareg"],
    /* vw: boxster, eos */
    ["porsche|boxster","volkswagen|eos"],
    /* gm: equinox, torrent */
    ["chevy|equinox","pontiac|torrent"],
    /* nissan: i30, maxima */
    ["infiniti|i30","nissan|maxima"],
    /* ford: f150, mountaineer */
    ["ford|f150","mercury|mountaineer"],
    /* ford: taurusx, sable */
    ["ford|taurusx","mercury|sable"],
    /* hk: veracruz, telluride */
    ["hyundai|veracruz","kia|telluride"],
    /* hk: sonata, soul */
    ["hyundai|sonata","kia|soul"],
    /* hk: elantra, soul */
    ["hyundai|elantra","kia|soul"],
    /* hk: santafe, optima */
    ["hyundai|santafe","kia|optima"],
    /* stla: dart, renegade */
    ["dodge|dart","jeep|renegade"],
    /* gm: colorado, canyon */
    ["chevy|colorado","gmc|canyon"],
    /* gm: equinox, terrain */
    ["chevy|equinox","gmc|terrain"],
    /* gm: hhr, vue */
    ["chevy|hhr","saturn|vue"],
    /* stla: sebring, avenger */
    ["chrysler|sebring","dodge|avenger"],
    /* gm: cts, camaro */
    ["cadillac|cts","chevy|camaro"],
    /* stla: concorde, intrepid */
    ["chrysler|concorde","dodge|intrepid"],
    /* gm: elr, volt */
    ["cadillac|elr","chevy|volt"]
  ]
};
